<h2 mat-dialog-title>
    Attendance for <student-name [firstName]="student.FirstName" [lastName]="student.LastName" [middleName]="student.MiddleName"
                                 [nickName]="student.NickName"></student-name>
</h2>
<mat-dialog-content style="padding-top: 0 !important;">
    <div style="width: 100%">
        <mat-table style="width: 100%;" [dataSource]="attendanceDetails">
            <!-- Date Column -->
            <ng-container matColumnDef="date">
                <mat-header-cell style="flex: 1" *matHeaderCellDef>Date</mat-header-cell>
                <mat-cell style="flex: 1" *matCellDef="let e">{{e.AttDate | date: 'MM/dd/yy'}}</mat-cell>
            </ng-container>
            <!-- Code Column -->
            <ng-container matColumnDef="code">
                <mat-header-cell style="flex: 1" *matHeaderCellDef>Code</mat-header-cell>
                <mat-cell style="flex: 1" *matCellDef="let e">{{e.AttCode}}</mat-cell>
            </ng-container>
            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <mat-header-cell style="flex: 2" *matHeaderCellDef>Description</mat-header-cell>
                <mat-cell style="flex: 2" *matCellDef="let e">{{e.AttCodeDescription}}</mat-cell>
            </ng-container>
            <!-- Comment Column -->
            <ng-container matColumnDef="comment">
                <mat-header-cell style="flex: 2" *matHeaderCellDef>Comment</mat-header-cell>
                <mat-cell style="flex: 2" *matCellDef="let e">{{e.AttComment}}</mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row style="min-height: 30px;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex-footer-left"></div>
    <div class="flex-footer-right">
        <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()" translate></tyl-button>
    </div>
</mat-dialog-actions>
